module.exports = __webpack_public_path__ + "static/media/intro-2.e6f0d777.png";